import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const COOKIE_CONSENT_KEY = 'cookie_consent';
const PRIVATE_ROUTE_PREFIXES = [
  '/dashboard', '/profile', '/company', '/settings', '/team',
  '/appraisals', '/admin', '/leads', '/analytics', '/business',
  '/auth/', '/mileage', '/share/', '/engagement/',
];

function isPublicRoute(pathname: string): boolean {
  return !PRIVATE_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix));
}

export function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_CONSENT_KEY) && isPublicRoute(location.pathname)) {
      setVisible(true);
    }
  }, [location.pathname]);

  if (!visible) return null;

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined');
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 bg-background/95 backdrop-blur border-t shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-4">
        <p className="text-sm text-muted-foreground flex-1">
          We use cookies and analytics to improve your experience. By continuing to use this site, you consent to our use of cookies.
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={decline}>
            Decline
          </Button>
          <Button size="sm" onClick={accept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
}
